import script from "./TodoList.vue?vue&type=script&setup=true&lang=js"
export * from "./TodoList.vue?vue&type=script&setup=true&lang=js"

import "./TodoList.vue?vue&type=style&index=0&id=48dd447c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48dd447c"]])

export default __exports__